// Generated from assets/icons/activity-dot-active.svg (TA-11013).
// Ids are derived per instance via useSvgIdPrefix() so two copies on one
// screen cannot collide. Edit this file rather than re-adding the .svg.
import * as React from 'react';
import Svg, { Path, Defs, LinearGradient, Stop } from 'react-native-svg';

import { useSvgIdPrefix } from '@hooks/useSvgIdPrefix';

import type { SvgProps } from 'react-native-svg';

export const ActivityDotActive = (props: SvgProps) => {
  const uid = useSvgIdPrefix();
  return (
    <Svg fill='none' viewBox='16 15 24 24' {...props}>
      <Path
        fill={`url(#${uid}-a)`}
        d='M19.464 35.536C18 34.07 18 31.713 18 27s0-7.071 1.464-8.536C20.93 17 23.287 17 28 17s7.071 0 8.536 1.464C38 19.93 38 22.287 38 27s0 7.071-1.464 8.536C35.07 37 32.713 37 28 37s-7.071 0-8.536-1.464'
      />
      <Path
        stroke='#035B60'
        strokeLinecap='round'
        strokeLinejoin='round'
        d='M22.45 26.985h2.49L26.934 23l2.99 7.97 1.992-3.985h2.49'
      />
      <Defs>
        <LinearGradient
          id={`${uid}-a`}
          x1={21.5}
          x2={43}
          y1={19.5}
          y2={42}
          gradientUnits='userSpaceOnUse'>
          <Stop stopColor='#97D8C6' />
          <Stop offset={1} stopColor='#32866F' />
        </LinearGradient>
      </Defs>
    </Svg>
  );
};
